'use client';

import { useTranslations } from 'next-intl';
import { FileText } from 'lucide-react';
import LegalPageLayout from '@/components/legal/LegalPageLayout';

export default function Impressum() {
  const t = useTranslations();

  return (
    <LegalPageLayout titleKey="legal.imprint.title" icon={FileText} iconColor="text-blue-600">
      <div className="mb-8 rounded-2xl bg-gray-50 p-6">
        <h2 className="mb-4 text-2xl font-semibold text-gray-950">
          {t('legal.imprint.legalNotice')}
        </h2>
        <div className="text-gray-700">
          <strong>{t('legal.company.name')}</strong>
          <br />
          {t('legal.company.address')}
          <br />
          {t('legal.company.city')}
          <br />
          {t('legal.company.country')}
        </div>
      </div>

      <div className="mb-8 grid gap-8 md:grid-cols-2">
        <div className="rounded-2xl bg-gray-50 p-6">
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            {t('legal.imprint.representative')}
          </h2>
          <p className="text-gray-700">
            {t('legal.imprint.representativeRole')}: {t('legal.company.ceo')}
          </p>
        </div>

        <div className="rounded-2xl bg-gray-50 p-6">
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            {t('legal.imprint.contact')}
          </h2>
          <p className="text-gray-700">
            Telefon:{' '}
            <a href={`tel:${t('legal.company.phone')}`} className="text-blue-600 hover:underline">
              {t('legal.company.phone')}
            </a>
            <br />
            E-Mail:{' '}
            <a
              href={`mailto:${t('legal.company.email')}`}
              className="text-blue-600 hover:underline"
            >
              {t('legal.company.email')}
            </a>
          </p>
        </div>
      </div>

      <div className="mb-8 grid gap-8 md:grid-cols-2">
        <div className="rounded-2xl bg-gray-50 p-6">
          <h2 className="mb-3 text-xl font-semibold text-gray-950">
            {t('legal.imprint.registerEntry')}
          </h2>
          <p className="text-gray-700">
            {t('legal.imprint.registerEntryText')}
            <br />
            {t('legal.imprint.registerCourt')}: {t('legal.company.registerCourt')}
            <br />
            {t('legal.imprint.registerNumber')}: {t('legal.company.registerNumber')}
          </p>
        </div>

        <div className="rounded-2xl bg-gray-50 p-6">
          <h2 className="mb-3 text-xl font-semibold text-gray-950">
            {t('legal.imprint.vatId')}
          </h2>
          <p className="text-gray-700">
            {t('legal.imprint.vatIdText')}:
            <br />
            <strong>{t('legal.company.vatId')}</strong>
          </p>
        </div>
      </div>

      <div className="mb-8 rounded-2xl bg-gray-50 p-6">
        <h2 className="mb-3 text-xl font-semibold text-gray-950">
          {t('legal.imprint.profession')}
        </h2>
        <p className="text-gray-700">
          {t('legal.imprint.professionTitle')}: {t('legal.imprint.professionText')}
          <br />
          {t('legal.imprint.chamber')}: {t('legal.imprint.chamberName')}
          <br />
          {t('legal.imprint.grantedIn')}: {t('legal.company.country')}
        </p>
      </div>

      <div className="mb-8 rounded-2xl bg-gray-50 p-6">
        <h2 className="mb-3 text-xl font-semibold text-gray-900">
          {t('legal.imprint.editorialResponsibility')}
        </h2>
        <p className="text-gray-700">
          {t('legal.company.ceo')}
          <br />
          {t('legal.company.address')}
          <br />
          {t('legal.company.city')}
          <br />
          {t('legal.company.country')}
        </p>
      </div>

      <h2>{t('legal.imprint.euDispute.title')}</h2>
      <p>
        {t('legal.imprint.euDispute.text')}
        <a
          href={t('legal.imprint.euDispute.link')}
          className="ml-1 text-blue-600 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('legal.imprint.euDispute.link')}
        </a>
        .<br />
        {t('legal.imprint.euDispute.emailNotice')}
      </p>

      <h2>{t('legal.imprint.consumerDispute.title')}</h2>
      <p>{t('legal.imprint.consumerDispute.text')}</p>

      <p className="mt-12 text-sm text-gray-500">
        {t('legal.imprint.source.label')}{' '}
        <a
          href={t('legal.imprint.source.link')}
          className="text-blue-600 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('legal.imprint.source.linkText')}
        </a>
      </p>
    </LegalPageLayout>
  );
}
